export const TIPO_AMORTIZACION_ACTIVO = {
  LINEAL: 1,
  CRECIENTE: 2,
  DECRECIENTE: 3,
} as const

export type TipoAmortizacionActivoType =
  (typeof TIPO_AMORTIZACION_ACTIVO)[keyof typeof TIPO_AMORTIZACION_ACTIVO]
